export const StaticImage = ({pdf = false, src, alt}: {pdf?: boolean; src: string; alt: string}) => {
  const Image = ({src, alt}: {src: string; alt: string}) => {
    return (
      <img
        className="not-prose m-0 block w-full bg-bg-secondary-hover object-cover transition-all"
        src={src}
        alt={alt}
        data-id="step-image"
      />
    );
  };

  return (
    <div className="relative box-border flex h-full overflow-hidden rounded-md border bg-bg-secondary transition-all">
      {pdf ? (
        <div className="relative h-[380px] w-full overflow-hidden">
          <Image src={src} alt={alt} />
        </div>
      ) : (
        <Image src={src} alt={alt} />
      )}
    </div>
  );
};
